import { render } from "./calendar.vue?vue&type=template&id=770d4126&scoped=true"
import script from "./calendar.vue?vue&type=script&lang=js"
export * from "./calendar.vue?vue&type=script&lang=js"

import "./calendar.vue?vue&type=style&index=0&id=770d4126&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770d4126"]])

export default __exports__